import platform from './node/index.js';

export {platform as default}



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/index.js
// module id = 9
// module chunks = 0